import { Rule } from '@webkit/validation/value';

export const fileTypes = (fileTypes: string[], error?: string) =>
    ({
        id: 'file-types',
        validator: files => {
            if (!files) return true;

            const allowed = fileTypes.map(ft => ft.replace('.', '').toLowerCase());
            return files.every(file => {
                const extension = file.name.split('.').pop()?.toLowerCase();
                return extension ? allowed.includes(extension) : false;
            });
        },
        error: () => {
            if (error) return error;

            const list = fileTypes.map(ext => ext.replace('.', ''));

            const extensions =
                list.length === 1
                    ? `.${list[0]}`
                    : list
                          .slice(0, -1)
                          .map(e => `.${e}`)
                          .join(', ') +
                      ' or .' +
                      list.slice(-1);

            return `Must be a ${extensions} file`;
        },
    } as Rule<File[]>);
